import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import TriggerRuleInfo from 'records/TriggerRuleInfo';
import './TriggerNameDialog.styl';
import TextAreaField from 'components/pure/utils/form/TextAreaField';

export default class TriggerNameDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: (props.rule && props.rule.name) || '',
    };
  }

  render() {
    const {open, onCancel, rule} = this.props;
    const {name} = this.state;
    return (
      <Dialog
        contentClassName="trigger-name-dialog"
        open={open}
        title="Rename Smart Alert"
        onRequestClose={onCancel}
        actions={[
          <Button
            variant="text"
            className="ev-button"
            onClick={async () => {
              try {
                const updatedRule = await TriggerRuleActions.updateTriggerName(rule.id);
                this.setState({name: updatedRule.name});
              } catch (e) {
                console.error(e);
              }
            }}>
            Restore Default Name
          </Button>,
          <Button variant="outlined" className="ev-button" onClick={onCancel}>
            Cancel
          </Button>,
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={() =>
              TriggerRuleActions.updateTriggerName(rule.id, name)
                .then(onCancel)
                .catch(console.error)
            }>
            Submit
          </Button>,
        ]}>
        <TextAreaField
          style={{height: 'unset'}}
          rows="4"
          value={name}
          onChange={name => this.setState({name})}
        />
      </Dialog>
    );
  }
}

TriggerNameDialog.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func, // () => void
  rule: PropTypes.instanceOf(TriggerRuleInfo),
};
